import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { switchMap } from 'rxjs/operators';
import { UtilHelper } from '../../../_helpers/util';
import { environment } from '../../../../environments/environment';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { OperacionService, GeneralService, IndicadorProgramacionService, SeguimientoPdesService } from '../../../services/service.index';
import { DxDataGridComponent, DxScrollViewComponent, DxDataGridModule, DxSelectBoxComponent, DxCheckBoxModule, DxTemplateModule } from 'devextreme-angular';
import { formatDate } from '@angular/common';
declare var jQuery: any;
declare var toastr;

@Component({
  selector: 'app-indicadores',
  templateUrl: './indicadores.component.html',
  styleUrls: []
})
export class IndicadoresComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  popupVisibleUs: boolean = false;
  lstVariableMes: any[] = [];
  indicadorId: number = 0;
  dataUsers: any[];
  indicador: string = '';
  rol: string ='';
  userId: number=0;
  constructor(private _ss: SeguimientoPdesService, private _gs: GeneralService) { 

    //this.metaGestion = JSON.parse(localStorage.getItem('g'));
    let u = JSON.parse(localStorage.getItem('u'));
    this.rol = u.rol;
    this.userId = u.id;
    this.getIndicadorUser();

  }
  selectedRows: number[];
  ngOnInit() {
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    },);
  }
  
  showModalUser(dg: any) {    
    this.indicadorId = dg.id;    
    this._ss.getUsuarios(dg.id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
    
          this.dataUsers = result.data;
          this.selectedRows = this.dataUsers.filter(u => u.seleccionado == 1).map(u => u);
        } else {
          this.dataUsers = [];
          this.selectedRows = [];
        }
      });
    
    this.indicador = dg.indicador_pdes;
    this.popupVisibleUs = true;
  }

  getIndicadorUser() {    
    this._ss.getIndicadoresPdes().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {                    
          this.lstVariableMes = result.data;          
        }
        else { this.lstVariableMes = []; }
      },
      (error) => { console.log('Error', error); });
  }

  saveUsers(a: any) {    
    this._ss.postUsuariosIndicador({ indicador_pdes_id: this.indicadorId, users: a.selectedRowKeys }).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          toastr.success('Usuarios asignados correctamente.');
          this.popupVisibleUs = false;
        }
      });
    this.indicadorId = 0;
    
  }

}
